import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ReviewsSection from '../home/components/ReviewsSection';

export default function ReviewsPage() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Navbar />
      <div className="pt-16">
        {/* Page header */}
        <div className="bg-[#0D0D0D] py-20 px-6">
          <div className="max-w-7xl mx-auto">
            <span className="inline-block bg-[#FF6B35]/20 text-[#FF6B35] text-xs font-bold px-3 py-1 rounded-full mb-4 tracking-widest uppercase">
              Establishment Reviews
            </span>
            <h1 className="text-white font-black" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(40px, 6vw, 72px)', letterSpacing: '0.02em' }}>
              Customer Reviews
            </h1>
            <p className="text-white/60 text-sm max-w-lg mt-2">
              Honest reviews from verified customers across Georgetown, Guyana. Find the best partner stores.
            </p>
          </div>
        </div>
        <ReviewsSection />
      </div>
      <Footer />
    </div>
  );
}
